import React, { useState } from "react";
import { Download, Share, Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import useInstallPrompt from "@/hooks/useInstallPrompt";

export default function InstallButton({ variant = "solid", className = "" }) {
  const { canInstall, promptInstall, isIOS } = useInstallPrompt();
  const [iosOpen, setIosOpen] = useState(false);

  if (!canInstall) return null;

  const handleClick = () => {
    if (isIOS) setIosOpen(true);
    else promptInstall();
  };

  const base =
    variant === "solid"
      ? "bg-[color:var(--vault-brand)] hover:bg-[color:var(--vault-brand-hover)] text-white"
      : "border border-[color:var(--vault-border)] bg-white hover:bg-[color:var(--vault-brand-light)] text-[color:var(--vault-text-primary)]";

  return (
    <>
      <Button
        onClick={handleClick}
        className={`rounded-xl ${base} ${className}`}
        data-testid="install-app-btn"
      >
        <Download size={16} className="mr-1.5" />
        Install app
      </Button>

      <Dialog open={iosOpen} onOpenChange={setIosOpen}>
        <DialogContent className="sm:max-w-sm bg-white rounded-2xl" data-testid="ios-install-dialog">
          <DialogHeader>
            <DialogTitle className="font-[Outfit] text-xl">Add to Home Screen</DialogTitle>
            <DialogDescription>Install EZGuard on your iPhone or iPad in two taps.</DialogDescription>
          </DialogHeader>
          <ol className="space-y-3 text-sm mt-1">
            <li className="flex items-center gap-3">
              <span className="w-6 h-6 rounded-full bg-[color:var(--vault-brand-light)] text-[color:var(--vault-brand)] text-xs font-semibold flex items-center justify-center shrink-0">1</span>
              <span className="flex items-center gap-1.5">Tap the <Share size={15} className="inline text-[color:var(--vault-brand)]" /> <strong>Share</strong> button in Safari.</span>
            </li>
            <li className="flex items-center gap-3">
              <span className="w-6 h-6 rounded-full bg-[color:var(--vault-brand-light)] text-[color:var(--vault-brand)] text-xs font-semibold flex items-center justify-center shrink-0">2</span>
              <span className="flex items-center gap-1.5">Choose <Plus size={15} className="inline text-[color:var(--vault-brand)]" /> <strong>Add to Home Screen</strong>.</span>
            </li>
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
}
